import { number, shape, string } from 'prop-types'

export const shippingType = shape({
  id: string.isRequired,
  name: string.isRequired,
  logoUrl: string.isRequired,
  description: string.isRequired,
  price: number.isRequired,
  threshold: number.isRequired,
})
